{
  "en": {
    "mainFobizzNavbar": {
      "a11y": {
        "actions": "Actions",
        "closeNavigation": "Close navigation",
        "mainNav": "Main navigation",
        "openNavigation": "Open navigation",
        "skipToContent": "Skip to content",
        "closeFlyout": "Close flyout"
      },
      "login": "Login",
      "logoHint": "Click here to return to the homepage",
      "myfobizz": {
        "headers": {
          "adminArea": "Admin Area 🤓",
          "myfobizz": "My fobizz"
        },
        "links": {
          "backofficePlatform": "Backoffice",
          "contact": "Help and Contact",
          "folders": "My Content",
          "histories": "My History",
          "news": "News",
          "partnersOverview": "Partners Overview",
          "profile": "My Profile",
          "features": "Feature Flags",
          "reviewerSection": "Reviewer Section",
          "subscriptions": "My Licences",
          "timetable": "Timetable",
          "toTeach": "To to teach"
        }
      },
      "navbarSearch": {
        "placeholder": "Quick access",
        "results": {
          "courses": "Courses",
          "empty": " No results",
          "materials": "Teaching materials",
          "myContent": "My Content",
          "schoolClassesAndProjects": "Classrooms and Projects",
          "showAll": "Show all",
          "showAllSchoolClasses": "To the Classrooms",
          "showAllTools": "To the Tools",
          "showAllWithCount": "Show all {count}",
          "tools": "Tools"
        }
      },
      "breadcrumb": {
        "tools": "Tools"
      },
      "pupilLogin": {
        "text": "Work with AI assistance and teaching materials. You will receive your individual access from your teacher.",
        "title": "Log in as a student"
      },
      "signup": {
        "text": "Create a free account and get limited access to courses, tools and teaching materials.",
        "title": "Sign up"
      },
      "teacherLogin": {
        "text": "Create and manage teaching materials for your class and unlock AI for your projects.",
        "title": "Log in as a teacher"
      },
      "tooltips": {
        "homepage": "Go to homepage",
        "myfobizz": "My fobizz",
        "search": "Quick access to all courses and teaching materials"
      },
      "coachmarkTour": {
        "title": "New Navigation",
        "next": "Next",
        "done": "Done",
        "steps": {
          "step1": "With the new navigation, you can access the most important areas and functions even faster.",
          "step2": "Under Workspace, you'll find your storage, shared spaces, and timetables all in one place.",
          "step3": "Through your avatar, you can keep track of your license status and access other important information."
        }
      },
      "sharedLibraryHint": {
        "title": "NEW: Shared Space",
        "headline": "Share materials",
        "body": "Store content in the Shared Space so your colleagues can use it. Like a digital materials cabinet.",
        "confirm": "OK"
      },
      "licenseInfo": {
        "summary": "{type}: {areas}",
        "types": {
          "einzel": "Single License",
          "schul": "School License"
        },
        "areas": {
          "courses": "Courses",
          "tools": "Tools",
          "toTeach": "to teach"
        },
        "limited": "Limited use (Upgrade)"
      },
      "offcanvas": {
        "headers": {
          "organize": "Workspace",
          "mySchool": "My School",
          "settings": "Settings",
          "partners": "Partners"
        },
        "links": {
          "sharedLibrary": "Shared Storage",
          "classes": "Shared Spaces",
          "schoolOverview": "Overview",
          "licenseManagement": "License Management",
          "internalWorkshops": "Internal Workshops",
          "authorArea": "Author Section"
        }
      },
      "tabs": {
        "start": "Home",
        "organize": "Workspace",
        "tools": "Tools",
        "material": "Materials",
        "partner": "Partners",
        "courses": "Courses"
      },
      "flyout": {
        "organize": {
          "folders": {
            "headline": "My Content",
            "description": "Your materials in one place",
            "linkLabel": "To storage"
          },
          "sharedLibrary": {
            "headline": "Shared Storage",
            "description": "Share material with your school group",
            "linkLabel": "To storage"
          },
          "classes": {
            "headline": "Shared Spaces",
            "description": "Create shared spaces and work with students",
            "linkLabel": "Create shared space",
            "linkLabelPopulated": "Show all"
          },
          "timetable": {
            "headline": "Timetable",
            "description": "Plan lessons and link materials",
            "linkLabel": "Create timetable",
            "linkLabelPopulated": "Show",
            "todayTime": "today, {time}"
          }
        },
        "material": {
          "partner": {
            "headline": "fobizz & Partners",
            "description": "Materials from fobizz and partners",
            "linkLabel": "Explore Materials"
          },
          "toTeach": {
            "headline": "Content",
            "description": "Materials from to teach",
            "linkLabel": "Explore Materials"
          },
          "community": {
            "headline": "fobizz Community",
            "description": "Materials from the fobizz Community",
            "linkLabel": "Explore Materials"
          },
          "bookmarks": {
            "headline": "Bookmarked Material",
            "description": "Bookmarked materials",
            "linkLabel": "View bookmarks"
          }
        },
        "tools": {
          "aiChat": {
            "headline": "AI Chat and Assistants",
            "items": {
              "chat": "Chat with AI",
              "assistants": "Assistants Catalog",
              "miniTool": "Prompt Lab"
            }
          },
          "multimedia": {
            "headline": "AI Multimedia Tools",
            "items": {
              "image": "Image Generator",
              "podcast": "Podcast Creator",
              "transcript": "Transcription Generator"
            }
          },
          "material": {
            "headline": "Create material",
            "items": {
              "worksheet": "Worksheet",
              "classroomScreen": "Teaching Board",
              "survey": "Survey"
            }
          },
          "share": {
            "headline": "Share content",
            "items": {
              "fileSharing": "File Sharing",
              "qrCode": "QR Code Generator",
              "linkShortener": "URL Shortener"
            }
          },
          "showAll": "Show all",
          "showAllTools": "Show all tools"
        },
        "start": {
          "stats": {
            "fortbildungen": "Course | Courses",
            "materialien": "Material | Materials",
            "klassen": "Shared Space | Shared Spaces",
            "prompts": "Prompt | Prompts"
          }
        },
        "courses": {
          "catalog": {
            "headline": "Course catalog",
            "liveWebinare": "Live webinars",
            "fortbildungen": "Courses",
            "linkLabel": "To the course catalog"
          },
          "myCourses": {
            "headline": "My courses",
            "descriptionEmpty": "You have no active courses and additional qualifications",
            "activeCount": "Active Courses ({count})",
            "bookmarkedCount": "Bookmarked Courses ({count})",
            "linkLabel": "To My Courses",
            "linkLabelEmpty": "Discover courses"
          },
          "additionalQualifications": {
            "headline": "Additional Qualifications",
            "description": "Sign up now for the new ZQ’s in the 2026/2027 school year",
            "linkLabel": "To the Info Page"
          },
          "aiLiteracyTraining": {
            "headline": "AI Literacy Training",
            "description": "Join our free, online AI Literacy Training for educators.",
            "linkLabel": "Learn more & register"
          }
        }
      },
      "mobileNav": {
        "tools": {
          "showAll": "Show all"
        }
      },
      "startPage": {
        "greeting": "Hello {user}!",
        "greetingFallback": "Hello!",
        "subtitle": "Welcome to fobizz.",
        "welcomeBack": "Welcome back.",
        "news": {
          "headline": "News",
          "linkLabel": "Show all news"
        },
        "toTeach": {
          "label": "Teaching Material | Teaching Materials",
          "linkLabel": "to teach: {count} Teaching Material, open in new tab | to teach: {count} Teaching Materials, open in new tab"
        }
      }
    }
  }
}
